var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHeadUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.7168,
    y: 10.3457,
    width: 1.68222,
    height: 12.9189,
    rx: 0.841109,
    transform: "rotate(-135 1.7168 10.3457)",
    fill: "#3B1F8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 8.84961,
    width: 1.68222,
    height: 12.4983,
    rx: 0.841109,
    transform: "rotate(135 18.5 8.84961)",
    fill: "#3B1F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeadUpBlue);
export default __webpack_public_path__ + "static/media/arrowHeadUpBlue.f32be2ef9a423301f86370f59bafb9ff.svg";
export { ForwardRef as ReactComponent };